import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const CaptionAccentTypography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true }, ref) => (
		<h4
			ref={ref}
			className={cn(`scroll-m-20 ${truncate ? 'truncate' : ''} text-xs font-medium `, className)}
			data-testid={`caption-accent-typography-${children?.toString().toLowerCase().replace(/\s+/g, '-')}`}
		>
			{children}
		</h4>
	)
);

CaptionAccentTypography.displayName = 'CaptionAccentTypography';

export default CaptionAccentTypography;
